import React from "react";
import { Tab, Nav, Card, Button } from "react-bootstrap";
import { ArrowLeft, CashStack, Gear } from "react-bootstrap-icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import paths from "routes/paths";
import PreauthPayerResponse from "./new-view-preauth-components/PreauthPayerResponse";
import PreauthResponseService from "./new-view-preauth-components/PreauthResponseService";

const PreauthorizationPayerResponse = ({ row, show }) => {
  const { viewPreauthorizationInfo } = useSelector(
    (state) => state.preauthorization
  );

  const { id } = useParams();

  const { claimRequestData } = useSelector((state) => state.claim);
  const navigate = useNavigate();
  const location = useLocation();

  const hasClaim = location.pathname.includes("claim");
  return (
    <Tab.Container defaultActiveKey="nestedPayer">
      <Card multiSections>
        <Nav
          variant="tabs"
          className="border-0 d-flex align-items-center mb-2 px-2"
        >
          {id && (
            <Button
              variant="secondary"
              className=" me-3"
              size="sm"
              onClick={() =>
                navigate(
                  claimRequestData?.id
                    ? paths.claimsList
                    : paths.preauthorizationList
                )
              } // You can replace with custom logic
            >
              <ArrowLeft size={18} />
            </Button>
          )}
          <Nav.Item>
            <Nav.Link
              eventKey="nestedPayer"
              className="d-flex align-items-center gap-2"
            >
              <CashStack /> Payer Response
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="services"
              className="d-flex align-items-center gap-2"
            >
              <Gear />{" "}
              {viewPreauthorizationInfo?.is_advpreauth
                ? "Services & Diagnosis"
                : "Services & Procedures"}
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content className="p-3">
          {/* Remove extra Tab.Content wrapper */}
          <Tab.Pane eventKey="nestedPayer">

            <PreauthPayerResponse />

          </Tab.Pane>
          <Tab.Pane eventKey="services">

            <PreauthResponseService show={show} row={row} />

          </Tab.Pane>
        </Tab.Content>
      </Card>
    </Tab.Container>
  );
};

export default PreauthorizationPayerResponse;
